import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import classnames from 'classnames';
import css from './inline-alert.css';

const InlineAlert = ({ description, text, variant, ...otherProps }) => (
  <div
    className={classnames(css['ds-inline-alert'], {
      [css[`ds-inline-alert--${variant}`]]: variant,
    })}
    {...otherProps}
  >
    <strong className={css['ds-inline-alert__lede']}>{text}</strong>
    <span className={css['ds-inline-alert__description']}>{description}</span>
  </div>
);

InlineAlert.defaultProps = {
  description: '',
  text: '',
  variant: null,
};

InlineAlert.propTypes = {
  description: PropTypes.string,
  text: PropTypes.string,
  variant: PropTypes.oneOf(['error', 'success', 'warning']),
};

export default InlineAlert;
